<template>
    <span v-if="toast" :class="toastClass" v-html="toastMessage"></span>
    <div class="overlay"></div>
    <div class="reviewBox">
        <div>
            <a title="Close" class="close" @click="closeBox">X</a>
            <h3>Assign Project or Override {{ this.assignment && this.assignment.employee ? `for ${this.assignment.employee}` : '' }}</h3>
            <p class="bold">Only fill out fields that will be different than the main start.  Leave them blank to keep the main start values.</p>
            <hr />
        </div>
        <div class="col-xs-6">
            <fieldset class="form-group bold">
                <div class="col-xs-2">Field</div>
                <div class="col-xs-5">Main Start Value</div>
                <div class="col-xs-5">Override</div>
            </fieldset>
        </div>
        <div class="col-xs-6">
            <fieldset class="form-group bold">
                <div class="col-xs-2">Field</div>
                <div class="col-xs-5">Main Start Value</div>
                <div class="col-xs-5">Override</div>
            </fieldset>
        </div>
        <div class="clear"></div>
        <div class="col-xs-6">
            <fieldset v-if="showProjects" class="form-group">
                <div class="col-xs-2"><label for="assignment.project">Project</label></div>
                <div class="col-xs-5"><input class="form-control" id="assignment.project" name="assignment.project" v-model="assignment.project" title="" tabindex="-1" readonly></div>
                <!-- <div class="col-xs-5"><input class="form-control" id="overrideData.project" name="project" v-model="overrideData.project" title="" :readonly="readonly"></div> -->
                <div class="col-xs-5">
                    <div v-if="enableProBooks">
                        <!-- <autocomplete :key="iteration" :options="probooksProjects" name="project" @select="setData($event, 'project_id', 'project_number')" v-model="overrideData.projecid" ref="overrideData.project" :preselect="overrideData.project" :display="'project_name'" :search-props="['project_name', 'project_number']" placeholder="" :default-show="true" :highlight="-1" :display-changes="true"> -->
                        <autocomplete :key="iteration" :options="probooksProjects" name="project" @select="setData($event, {field: 'project_id', prop: 'project_number', displayField: 'project', displayProp: 'project_name'})" v-model="overrideData.projecid" ref="overrideData.project" :preselect="overrideData.project" :display="'project_name'" :search-props="['project_name', 'project_number']" placeholder="" :default-show="true" :highlight="-1" :display-changes="true" :readonly="readonly">
                            <template v-slot:item="option" >
                                <p><strong>{{ option.item.project_name }}</strong></p>
                                <!-- <p><strong>{{ JSON.stringify(option) }}</strong></p> -->
                            </template>
                        </autocomplete>
                    </div>
                    <div v-else>
                        <div class="col-xs-5"><input class="form-control" id="overrideData.project" name="project" v-model="overrideData.project" title="" :readonly="readonly"></div>
                    </div>
                </div>
            </fieldset>
            <fieldset class="form-group">
                <div class="col-xs-2"><label for="assignment.department">Department</label></div>
                <div class="col-xs-5"><input class="form-control" id="assignment.department" name="assignment.department" v-model="assignment.department" title="" tabindex="-1" readonly></div>
                <!-- <div class="col-xs-5"><input class="form-control" id="overrideData.department" name="department" v-model="overrideData.department" title="" :readonly="readonly"></div> -->
                <div class="col-xs-5">
                    <autocomplete :key="iteration" :options="departments" name="department" @select="setData($event, {field: 'department_id', prop: 'id', displayField: 'department', displayProp: 'name'})" v-model="overrideData.department" ref="overrideData.department" :preselect="overrideData.department" :display="'name'" placeholder="" :default-show="true" :highlight="-1" :display-changes="true" :readonly="readonly">
                        <template v-slot:item="option" >
                            <p><strong>{{ option.itemname }}</strong></p>
                        </template>
                    </autocomplete>
                </div>
            </fieldset>
            <fieldset class="form-group">
                <div class="col-xs-2"><label for="assignment.location">Work Site</label></div>
                <div class="col-xs-5"><input class="form-control" id="assignment.location" name="assignment.location" v-model="assignment.location" title="" tabindex="-1" readonly></div>
                <!-- <div class="col-xs-5"><input class="form-control" id="overrideData.location" name="location" v-model="overrideData.location" title="" :readonly="readonly"></div> -->
                <div class="col-xs-5">
                    <autocomplete :key="iteration" :options="projectLocations" name="location" @select="setData($event, {field: 'location_id', prop: 'id', displayField: 'location', displayProp: 'name'})" v-model="overrideData.location" ref="overrideData.location" :preselect="overrideData.location" :display="'code'" placeholder="" :default-show="true" :highlight="-1" :display-changes="true" :readonly="readonly">
                        <template v-slot:item="option" >
                            <p><strong>{{ option.itemname }}</strong></p>
                        </template>
                    </autocomplete>
                    <!-- <select class="form-control" name="location_id" v-bind:value="overrideData.location_id" ref="overrideData.location_id" @change="locationCheck" @select="locationCheck" required>
                        <option v-for="location in projectLocations" :value="location.id" :data-city="location.city" :data-state="location.state_id" :data-postal="location.postal">
                            {{location.name}}
                        </option>
                        <option value="addLocation">Add New Location</option>
                    </select> -->
                </div>
            </fieldset>
            <fieldset class="form-group">
                <div class="col-xs-2"><label for="assignment.date_start">Start</label></div>
                <div class="col-xs-5"><input class="form-control" id="assignment_start_date" name="assignment.start_date" v-model="assignment.start_date" title="" tabindex="-1" readonly></div>
                <!-- <div class="col-xs-2">
                    <date-field
                        name="start_date"
                        v-model="assignment.start_date"
                        reference="assignment.start_date"
                        ref="assignment.start_date"
                        :format="format"
                        :allowEmpty="false"
                        :placeholder="assignment.start_date"
                        :disabled="true"
                    />
                </div> -->
                <div class="col-xs-5">
                    <date-field
                        name="start_date"
                        v-model="overrideData.date_start"
                        reference="overrideData.date_start"
                        ref="overrideData.date_start"
                        :format="format"
                        :allowEmpty="false"
                        :placeholder="format.toUpperCase()"
                        :disabled="readonly"
                        @change="changed.date_start = true"
                        :classes="[ 'form-control', errors.date_start === true ? 'form-error' : '', changed.date_start === true ? 'form-change' : '' ]"
                    />
                </div>
                <!-- <div class="col-xs-5"><input class="form-control" id="date_start" name="assignment_date_start" v-model="overrideData.date_start" title="" tabindex="-1" :readonly="readonly"></div> -->
            </fieldset>
            <fieldset class="form-group">
                <div class="col-xs-2"><label for="assignment.date_end">End</label></div>
                <div class="col-xs-5"><input class="form-control" id="assignment.term_date" name="assignment.term_date" v-model="assignment.term_date" title="" tabindex="-1" readonly></div>
                <div class="col-xs-5">
                    <date-field
                        name="date_end"
                        @select="trackChange" v-model="overrideData.date_end"
                        reference="overrideData.date_end"
                        ref="overrideData.date_end"
                        :format="format"
                        :allowEmpty="false"
                        :placeholder="format.toUpperCase()"
                        :disabled="readonly"
                        @change="changed.date_end = true"
                        :classes="[ 'form-control', errors.date_start === true ? 'form-error' : '', changed.date_end === true ? 'form-change' : '' ]"
                    />
                </div>
            </fieldset>
            <fieldset class="form-group">
                <div class="col-xs-2"><label for="assignment.job_title">Job Title</label></div>
                <div class="col-xs-5"><input class="form-control" id="assignment.job_title" name="assignment.job_title" v-model="assignment.job_title_override" title="" tabindex="-1" readonly></div>
                <div class="col-xs-5"><input class="form-control" id="overrideData.job_title" name="job_title" v-model="overrideData.job_title_override" title="" :readonly="true || readonly"></div>
            </fieldset>
            <fieldset class="form-group">
                <div class="col-xs-2"><label for="assignment.rate">Rate</label></div>
                <div class="col-xs-5"><input class="form-control" id="assignment.rate" name="assignment.rate" v-model="assignment.rate" title="" tabindex="-1" readonly></div>
                <div class="col-xs-5"><input class="form-control" id="overrideData.rate" name="rate" v-model="overrideData.rate" title="" :readonly="true || readonly"></div>
            </fieldset>
            <fieldset class="form-group">
                <div class="col-xs-2"><label for="assignment.rate">Rate Unit</label></div>
                <div class="col-xs-5"><input class="form-control" id="assignment.rate_unit" name="assignment.rate_unit" v-model="assignment.rate_unit" title="" tabindex="-1" readonly></div>
                <div class="col-xs-5"><input class="form-control" id="assignment.rate_unit" name="assignment.rate_unit" v-model="assignment.rate_unit" title="" tabindex="-1" readonly></div>
            </fieldset>
            <fieldset class="form-group">
                <div class="col-xs-2"><label for="assignment.hourly_rate">Hourly Rate</label></div>
                <div class="col-xs-5"><input class="form-control" id="assignment.hourly_rate" name="assignment.hourly_rate" v-model="assignment.hourly_rate" title="" tabindex="-1" readonly></div>
                <div class="col-xs-5"><input class="form-control" id="overrideData.hourly_rate" name="hourly_rate" v-model="overrideData.hourly_rate" title="" :readonly="true || readonly"></div>
            </fieldset>
        </div>
        <div class="col-xs-6">
            <fieldset class="form-group">
                <div class="col-xs-2"><label for="assignment.budget_code">Budget Code</label></div>
                <div class="col-xs-5"><input class="form-control" id="assignment.budget_code" name="assignment.budget_code" v-model="assignment.budget_code" title="" tabindex="-1" readonly></div>
                <div class="col-xs-5">
                    <div v-if="enableProBooks">
                        <autocomplete :key="iteration" :options="probooksAccounts" name="budget_code" @select="setData($event, 'budget_code')" v-model="overrideData.budget_code" ref="overrideData.budget_code" :preselect="overrideData.budget_code" :display="'code'" placeholder="Acct" :default-show="true" :highlight="-1" :display-changes="true" :readonly="true || readonly">
                            <template v-slot:item="option" >
                                <p><strong>{{ option.code + ' - ' + option.itemname }}</strong></p>
                            </template>
                        </autocomplete>
                    </div>
                    <div v-else>
                        <div class="col-xs-5"><input class="form-control" id="overrideData.budget_code" name="budget_code" v-model="overrideData.budget_code" title="" :readonly="true || readonly"></div>
                    </div>
                </div>
            </fieldset>
            <fieldset class="form-group">
                <div class="col-xs-2"><label for="assignment.fringe_code">Fringe Code</label></div>
                <div class="col-xs-5"><input class="form-control" id="assignment.fringe_code" name="assignment.fringe_code" v-model="assignment.fringe_code" title="" tabindex="-1" readonly></div>
                <div class="col-xs-5">
                    <div v-if="enableProBooks">
                        <autocomplete :key="iteration" :options="probooksAccounts" name="fringe_code" @select="setData($event, 'fringe_code')" v-model="overrideData.fringe_code" ref="overrideData.fringe_code" :preselect="overrideData.fringe_code" :display="'code'" placeholder="Acct" :default-show="true" :highlight="-1" :display-changes="true" :readonly="true || readonly">
                            <template v-slot:item="option" >
                                <p><strong>{{ option.code + ' - ' + option.itemname }}</strong></p>
                            </template>
                        </autocomplete>
                    </div>
                    <div v-else>
                        <div class="col-xs-5"><input class="form-control" id="overrideData.fringe_code" name="fringe_code" v-model="overrideData.fringe_code" title="" :readonly="true || readonly"></div>
                    </div>
                </div>
            </fieldset>
            <fieldset class="form-group">
                <div class="col-xs-2"><label for="assignment.series_code">Series</label></div>
                <div class="col-xs-5"><input class="form-control" id="assignment.series_code" name="assignment.series_code" v-model="assignment.series_code" title="" tabindex="-1" readonly></div>
                <!-- <div class="col-xs-5"><input class="form-control" id="overrideData.series_code" name="series_code" v-model="overrideData.series_code" title="" :readonly="true || readonly"></div> -->
                <div class="col-xs-5">
                    <div v-if="enableProBooks">
                        <autocomplete :key="iteration" :options="probooksSeries" name="series_code" @select="setData($event, 'series_code')" v-model="overrideData.series_code" ref="overrideData.series_code" :preselect="overrideData.series_code" :display="'code'" placeholder="" :default-show="true" :highlight="-1" :display-changes="true" :readonly="true || readonly">
                            <template v-slot:item="option" >
                                <p><strong>{{ option.code + ' - ' + option.itemname }}</strong></p>
                            </template>
                        </autocomplete>
                    </div>
                    <div v-else>
                        <div class="col-xs-5"><input class="form-control" id="overrideData.series_code" name="series_code" v-model="overrideData.series_code" title="" :readonly="true || readonly"></div>
                    </div>
                </div>
            </fieldset>
            <fieldset class="form-group">
                <div class="col-xs-2"><label for="assignment.location_code">Loc</label></div>
                <div class="col-xs-5"><input class="form-control" id="assignment.location_code" name="assignment.location_code" v-model="assignment.location_code" title="" tabindex="-1" readonly></div>
                <!-- <div class="col-xs-5"><input class="form-control" id="overrideData.location_code" name="location_code" v-model="overrideData.location_code" title="" :readonly="true || readonly"></div> -->
                <div class="col-xs-5">
                    <div v-if="enableProBooks">
                        <autocomplete :key="iteration" :options="probooksLocations" name="location_code" @select="setData($event, 'location_code')" v-model="overrideData.location_code" ref="overrideData.location_code" :preselect="overrideData.location_code" :display="'code'" placeholder="" :default-show="true" :highlight="-1" :display-changes="true" :readonly="true || readonly">
                            <template v-slot:item="option" >
                                <p><strong>{{ option.code + ' - ' + option.itemname }}</strong></p>
                            </template>
                        </autocomplete>
                    </div>
                    <div v-else>
                        <div class="col-xs-5"><input class="form-control" id="overrideData.location_code" name="location_code" v-model="overrideData.location_code" title="" :readonly="true || readonly"></div>
                    </div>
                </div>
            </fieldset>
            <fieldset class="form-group">
                <div class="col-xs-2"><label for="assignment.set_code">Set</label></div>
                <div class="col-xs-5"><input class="form-control" id="assignment.set_code" name="assignment.set_code" v-model="assignment.set_code" title="" tabindex="-1" readonly></div>
                <!-- <div class="col-xs-5"><input class="form-control" id="overrideData.set_code" name="set_code" v-model="overrideData.set_code" title="" :readonly="true || readonly"></div> -->
                <div class="col-xs-5">
                    <div v-if="enableProBooks">
                        <autocomplete :key="iteration" :options="probooksSets" name="set_code" @select="setData($event, 'set_code')" v-model="overrideData.set_code" ref="overrideData.set_code" :preselect="overrideData.set_code" :display="'code'" placeholder="" :default-show="true" :highlight="-1" :display-changes="true" :readonly="true || readonly">
                            <template v-slot:item="option" >
                                <p><strong>{{ option.code + ' - ' + option.itemname }}</strong></p>
                            </template>
                        </autocomplete>
                    </div>
                    <div v-else>
                        <div class="col-xs-5"><input class="form-control" id="overrideData.set_code" name="set_code" v-model="overrideData.set_code" title="" :readonly="true || readonly"></div>
                    </div>
                </div>
            </fieldset>
            <fieldset class="form-group">
                <div class="col-xs-2"><label for="assignment.free_field">FF1</label></div>
                <div class="col-xs-5"><input class="form-control" id="assignment.free_field" name="assignment.free_field" v-model="assignment.free_field" title="" tabindex="-1" readonly></div>
                <!-- <div class="col-xs-5"><input class="form-control" id="overrideData.free_field" name="free_field" v-model="overrideData.free_field" title="" :readonly="true || readonly"></div> -->
                <div class="col-xs-5">
                    <div v-if="enableProBooks">
                        <autocomplete :key="iteration" :options="probooksFreeFields" name="free_field" @select="setData($event, 'free_field')" v-model="overrideData.free_field" ref="overrideData.free_field" :preselect="overrideData.free_field" :display="'name'" placeholder="" :default-show="true" :highlight="-1" :display-changes="true" :readonly="true || readonly">
                            <template v-slot:item="option" >
                                <p><strong>{{ option.code + ' - ' + option.itemname }}</strong></p>
                            </template>
                        </autocomplete>
                    </div>
                    <div v-else>
                        <div class="col-xs-5"><input class="form-control" id="overrideData.free_field" name="free_field" v-model="overrideData.free_field" title="" :readonly="true || readonly"></div>
                    </div>
                </div>
            </fieldset>
            <fieldset class="form-group">
                <div class="col-xs-2"><label for="assignment.free_field2">FF2</label></div>
                <div class="col-xs-5"><input class="form-control" id="assignment.free_field2" name="assignment.free_field2" v-model="assignment.free_field2" title="" tabindex="-1" readonly></div>
                <!-- <div class="col-xs-5"><input class="form-control" id="overrideData.free_field2" name="free_field2" v-model="overrideData.free_field2" title="" :readonly="true || readonly"></div> -->
                <div class="col-xs-5">
                    <div v-if="enableProBooks">
                        <autocomplete :key="iteration" :options="probooksFreeFields" name="free_field2" @select="setData($event, 'free_field2')" v-model="overrideData.free_field2" ref="overrideData.free_field2" :preselect="overrideData.free_field2" :display="'name'" placeholder="" :default-show="true" :highlight="-1" :display-changes="true" :readonly="true || readonly">
                            <template v-slot:item="option" >
                                <p><strong>{{ option.code + ' - ' + option.itemname }}</strong></p>
                            </template>
                        </autocomplete>
                    </div>
                    <div v-else>
                        <div class="col-xs-5"><input class="form-control" id="overrideData.free_field2" name="free_field2" v-model="overrideData.free_field2" title="" :readonly="true || readonly"></div>
                    </div>
                </div>
            </fieldset>
            <fieldset class="form-group">
                <div class="col-xs-1"></div>
                <div class="col-xs-11">
                    <input type="checkbox" id="send_start" name="send_start" v-model="send_start" title="" >
                    <label class="m-left-20" for="send_start">Send Start Documents</label>
                </div>
            </fieldset>
            <!-- <fieldset class="form-group">
                <div class="col-xs-2"><label for="assignment.FIELD">FIELD</label></div>
                <div class="col-xs-5"><input class="form-control" id="assignment.FIELD" name="assignment.FIELD" v-model="assignment.FIELD" title="" tabindex="-1" readonly></div>
                <div class="col-xs-5"><input class="form-control" id="overrideData.FIELD" name="FIELD" v-model="overrideData.FIELD" title="" :readonly="true || readonly"></div>
            </fieldset> -->
        </div>
        <div class="clear"></div>
        <hr />
        <div class="bold italic">
            To give a permanent raise to a person, please add only the rate and start date.
            <br />
            If you need to change the type of pay&mdash;like converting someone from hourly to exempt or non-union to union&mdash;you will need to <a href="/oasis/starts/create">create a new start</a>.
            <br />
            You can also use this to make minor changes for a temporary period by specifying one of the below options.
            This is useful if you know the employee will be working on a project or different location that requires a higher pay rate.
        </div>
        <div class="clear"></div>
        <div class="right">
            <span v-if="buttonNo">
                <button class="btn btn-default m-right-10" @click="closeBox"><span v-if="buttonNoLabel">{{buttonNoLabel}}</span><span v-else>Close</span></button>
            </span>
            <span v-if="buttonYes">
                <button class="btn btn-primary" @click="saveOverride" :disabled="readonly"><span v-if="buttonYesLabel">{{buttonYesLabel}}</span><span v-else>Save</span></button>
            </span>
        </div>
        <div class="clear"></div>
        <div v-if="showModal" class="modalDialog is-active" role="dialog" aria-labelledby="modal-title" aria-describedby="modal-description" aria-hidden="true" @keyup.esc="modalClose">
            <div class="modal-contents">
                <div>
                    <a title="Close" class="close" @click="showModal=false">X</a>
                    <h3><slot id="modal-title" name="header">Alert</slot></h3>
                    <hr />
                </div>
                <div>
                    <slot id="modal-description" name="body">
                        <span @click="showModal=false" v-html="modalMessage"></span>.
                    </slot>
                    <hr />
                </div>
                <div class="right">
                    <button class="btn btn-primary" @click="showModal=false">Close</button>
                </div>
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import 'regenerator-runtime/runtime';
import {defineComponent, ref} from 'vue';
import Axios from '../classes/Axios.js';
import DateField from './DateField.vue';
import autocomplete from '../components/autocomplete.vue';
import COAMixin from '../mixins/COAMixin.js';
import oasisModal from './oasis-modal.vue';

export default defineComponent ({
    name: "AssigmentOverride",

    mixins: [COAMixin],

    emits: ['close', 'save'],

    components: {
        'date-field': DateField,
        'oasis-modal': oasisModal,
        autocomplete,
    },

    props: {
        title: {
            type: String,
            default: 'Add Override',
            required: false
        },
        assignment: {
            type: Object,
            required: false,
        },
        override: {
            type: Object,
            required: false,
        },
        enableProBooks: {
            type: Boolean,
            required: false,
            default: false,
        },
        showProjects: {
            type: Boolean,
            required: false,
            default: false,
        },
        showAssignedProjects: {
            type: Boolean,
            required: false,
            default: false,
        },
        isTerminated: {
            type: Boolean,
            required: false,
            default: false,
        },
        adminAccess: {
            type: Boolean,
            required: false,
            default: false,
        },
        format: {
            type: String, 
            required: false,
            default: 'MM/dd/yyyy',
        },
        reference: {
            type: String,
            required: false,
            default: 'roster',
        },
        classes: {
            type: [ String, Array ],
            required: false,
            default: 'form-control'
        },
        columnIds: {
            type: Array,
            required: false,
        },
        buttonNo: {
            default: true
        },

        buttonYes: {
            default: true
        },

        buttonNoLabel: {
            type: String,
            required: false,
        },

        buttonYesLabel: {
            type: String,
            required: false,
        },
    },

    data() {
        return {
            // Override data
            overrideData: {},
            send_start: true,
            oasisV3Api: new Axios('/restv3'),
            departments: [],
            projectLocations: [],
            projects: [],

            loading: false, // spinner
            iteration: 0,
            localValueFormatter: function localValueFormatter(params) {
                var value = params.value;
                if (!value) return 'Non Union';
                return value;
            },
            generateIndividualStartFormModal: false,
            // searchQueryDateStart: undefined,
            // searchQueryDateEnd: undefined,
            locale: window.navigator.userLanguage || window.navigator.language || 'en-US', // 'fr-fr' // test stuff
            // link: '',
            showModal: false,
            modalMessage: '',
            errors: {},
            changed: {},
            // usesSplitForms: false,
            // availableForms: {},
            // selectedForms: ref([]),
            COAObj: undefined,
            coaRules: undefined,
            toast: false,
            toastMessage: '',
            toastClass: 'toast-success',
        }
    },

    computed: {
        readonly() {
            if (this.isTerminated) {
                return true;
            } else if (this.overrideData && this.overrideData.status >= 6) {
                return true;
            } else {
                return false;
            }
        },

        probooksAccounts() {
            if (!this.COAObj) return [];
            return this.COAObj.accounts || [];
        },

        probooksFreeFields() {
            if (!this.COAObj) return [];
            return this.COAObj.freeFields || [];
        },

        probooksSeries() {
            if (!this.COAObj) return [];
            return this.COAObj.series || [];
        },

        probooksLocations() {
            if (!this.COAObj) return [];
            return this.COAObj.locations || [];
        },

        probooksSets() {
            if (!this.COAObj) return [];
            return this.COAObj.sets || [];
        },

        probooksProjects() {
            if (!this.COAObj) return [];
            return this.COAObj.projects || [];
        },

        usesProbooksProjects() {
            return this.probooksProjects && this.probooksProjects.length > 0;
        },

        width() {
            // Reducing by 3 % to handle sigma-frontend navbar
            return '100%';
        },

        height() {
            // Reducing by 3 % to handle sigma-frontend navbar
            return window.innerHeight * 0.63 + 'px';
        },

        today() {
            let date = new Date();
            var day = date.getDate();
            var monthIndex = date.getMonth();
            var year = date.getFullYear();

            return year + '-' + this.pad(monthIndex * 1 + 1) + '-' + this.pad(day);
        },
        // Build a list of useable ag-grid column definitions from available columns
        columnDefs() {
            // Look for colIds from props first, and if not, use the default
            const columnIds = this.columnIds || this.defaultColumnDefs;
            var result = [];
            for (const i in columnIds) {
                const id = columnIds[i];
                const columnDef = this.availableColumnDefs.find((def) => def.colId === id || def.name === id);
                if (columnDef) result.push(columnDef);
            }
            return result;
        }
    },

    watch: {
        assignment(newValue, oldValue) {
            if (newValue) this.getOverrides();
            this.iteration++;
        },
        override(newValue, oldValue) {
            if (newValue) {
                // this.getOverride(overrideId);
                this.overrideData = Object.assign({}, this.override);
            }
            this.iteration++;
        },
    },

    methods: {
        closeBox(event) {
            this.$emit('close');
        },

        createDialog(message) {
            this.modalMessage = message;
            this.showModal = true;
        },

        // Get employee overrides from the Rest V3 Employer/startOverrides endpoint
        async getOverride(overrideId) {
            if (!this.overrideId) return false;
            this.loading = true;
            const endpoint = `/employer/startOverride/${overrideId}`;
            let response;
            try {
                response = await this.oasisV3Api.get(endpoint);
                // console.log('response', response);
            } catch (error) {
                console.error('Error fetching overrides:', error);
            }
            if (response && response.data) {
                this.overrideData = undefined;
                this.overrideData = response.data;
                // this.rowData = response.data.results;
            } else {
                // this.rowData = [];
            }

            this.loading = false;
        },

        getSelectedData() {
            if (!this.gridOptions) return [];
            return ((this.gridOptions.api || {}).getSelectedRows() || []);
        },

        getSelectedHashes() {
            if (!this.gridOptions) return [];
            return ((this.gridOptions.api || {}).getSelectedRows() || []).map((row) => row.hash);
        },

        async openAssignmentOverride(overrideId) {
            if (!overrideId) return false;
            // window.open(`/oasis/starts/approve/${overrideId}`, '_roster');
            alert('opening ' + overrideId);
        },

        exportToExcel() {
            const hashes = this.gridOptions.api.getSelectedRows().map((row) => row.hash) || [];
            if (hashes.length === 0) {
                this.createDialog('Please Select at least one item to export.');
                return;
            }
            this.gridOptions.api.exportDataAsExcel();
        },

        showToast(message, type='success') {
            this.toastMessage = message;
            this.toastClass = type === 'success' ? 'toast-success' : 'toast-error';
            this.toast = true;
            setTimeout(() => {
                this.message = '';
                this.toast = false;
            }, 1000 * 3);
        },

        /* Function to set our object to post/patch
        event: required data user input.
        options:
            field = required to set the patchable value
            prop = in the case of an event, need the name of the prop to use.  Will default to id
            displayField = if a friendly value should be set in addition to the id
            displayProp = in the case of an event, need the name of the prop to use for display
        */
        async setData(event, options) {
            // console.log(event, options);
            if (!event || !options || !options.field) return false;
            const field = options.field;
            const prop = options.prop || null;
            const displayField = options.displayField || null;
            const displayProp = options.displayProp || null;

            // 1. Set the ids needed for the post/patch
            // Explicitly set the field based on the event prop
            if (typeof event === 'object' && prop) {
                this.overrideData[field] = event[prop];
                this.changed[field] = true;
                // console.log(`Setting Field ${field} to ${event[prop]}`)

            // Do prop given, the to use the code or id
            } else if (typeof event === 'object' && event.code) {
                this.overrideData[field] = event.code;
                this.changed[field] = true;
                // console.log(`Setting Field ${field} to ${event.code}`)
            } else if (typeof event === 'object' && event.id) {
                this.overrideData[field] = event.id;
                this.changed[field] = true;
                // console.log(`Setting Field ${field} to ${event.id}`)

            // Use the value if not an object, e.g. normal inputs
            } else if (typeof event === 'string' || typeof event === 'number') {
                this.overrideData[field] = event;
                this.changed[field] = true;
                // console.log(`Setting Field ${field} to ${event}`)
            }

            // 2. If the field is an id, may need to set the displayed value
            if (displayField && displayProp) {
                this.overrideData[displayField] = event[displayProp];
                this.changed[displayField] = true;
                // console.log(`Setting displayField ${displayField} to ${event[displayProp]}`);
            } else if (displayField) {
                this.overrideData[displayField] = event.name || event.description || event.desc || event.code || '';
                this.changed[displayField] = true;
                // console.log(`Setting displayField ${displayField} to ${this.overrideData[displayField]}`);
            }

            // 3. For CPA projects, need to check our local projects list
            if (field === 'project_id' && this.usesProbooksProjects && typeof event === 'object') {
                const project = await this.getSubProject(event) || {};
                // console.log(project);
                this.overrideData[field] = project.id 
                this.overrideData.project = project.name
                // console.log(`Setting project_id/Project to : ${project.id} / ${project.name}`);
                // this.overrideData.project_id = event.id;
            }
        },

        // Add the project to the list of available to the entity
        async getSubProject(projectObject) {
            if (!projectObject || !this.usesProbooksProjects) return null;
            if (!this.projects) {
                this.projects = [];
            }
            const matchingProjects = this.projects.filter((proj) => proj.code === projectObject.project_number);
            if (matchingProjects && matchingProjects.length > 0) {
                // console.log('Match found', matchingProjects);
                return matchingProjects[0];
            } else {
                const data = {
                    code: projectObject.project_number,
                    name: projectObject.project_name,
                    description: '',
                    project_type_id: 1,
                    entity_id: this.assignment.entity_id,
                    signatory_number: null,
                    status: 1,
                };

                try {
                    const response = await this.oasisV3Api.post('/employer/subprojects', data);
                    // console.log(response)
                    // this.projects.push(response.data);
                    return response.data;
                } catch (error) {
                    console.error('Error fetching overrides:', error);
                    return null;
                }
            }
            return null;
        },

        resetOverride() {
            this.overrideData = undefined,
            this.overrideData = {
                assignment_id: this.assignment.id,
                status: 1,
                date_start: undefined,
                date_end: undefined,
                project_id: undefined,
                project: undefined,
                location_id: undefined,
                location: undefined,
                department_id: undefined,
                department: undefined,
                job_title_id: undefined,
                job_title: undefined,
                rate: undefined,
                rate_unit: undefined,
                hourly_rate: undefined,
                budget_code: undefined,
                series_code: undefined,
                location_code: undefined,
                set_code: undefined,
                free_field: undefined,
                free_field2: undefined,
            };
        },

        // setDefaultOverride() {
        //     if (!this.assignment) return false;
        //     this.overrideData = undefined,
        //     this.overrideData = {
        //         assignment_id: this.assignment.id,
        //         date_start: this.assignment.start_date,
        //         date_end: this.assignment.term_date,
        //         project_id: this.project_id,
        //         project: this.project,
        //         location_id: this.location_id,
        //         location: this.location,
        //         department_id: this.department_id,
        //         department: this.department,
        //         job_title_id: this.job_title_id,
        //         job_title: this.job_title,
        //         rate: this.rate,
        //         rate_unit: this.rate_unit,
        //         hourly_rate: undefined,
        //     };
        //     console.log('resetOverride', this.overrideData)
        // },

        validate() {
            if (!this.overrideData) {
                // this.createDialog('An override must have a start date, and one of the following must be different from the main start: project, department, job title, or rate.');
                this.showToast('An override must have a start date, and one of the following must be different from the main start: project, department, job title, or rate.', 'error');
                return false;
            } else if (!this.overrideData.date_start) {
                // this.createDialog('Please enter a valid start date.');
                this.showToast('Please enter a valid start date.', 'error');
                return false;
            } else if (this.overrideData.date_end && new Date(this.overrideData.date_end) < new Date(this.overrideData.date_start)) {
                // this.createDialog('Please enter a valid end date that is later than the start date.');
                this.showToast('Please enter a valid end date that is later than the start date.');
                return false;
            } else if (!this.overrideData.project_id && !this.overrideData.department_id && !this.overrideData.job_title_id && !this.overrideData.rate) {
                // this.createDialog('Please enter at least one of the following: project, department, job title, or rate.');
                this.showToast('Please enter at least one of the following: rate for a raise, and/or project or job title to assign a temporary change.');
                return false;
            }
            return true;
        },

        // Load data for autocomplete
        async getOptionsdata() {
            let responseCoaRules, responseDepartments, responseProjectLocations, responseProjects;
            try {
                responseCoaRules = await this.oasisV3Api.get(`/employer/coaRules?entity_id=${this.assignment.entity_id}`);
            } catch (error) {
                console.error('Error fetching overrides:', error);
            }
            if (responseCoaRules && responseCoaRules.data && responseCoaRules.data.results) {
                this.coaRules = responseCoaRules.data.results;
            }

            try {
                responseDepartments = await this.oasisV3Api.get('/employer/departments');
                // console.log(responseDepartments)
            } catch (error) {
                console.error('Error fetching overrides:', error);
            }
            if (responseDepartments && responseDepartments.data && responseDepartments.data.results) {
                this.departments = responseDepartments.data.results;
            }

            try {
                responseProjectLocations = await this.oasisV3Api.get('/employer/locations');
                // console.log(responseProjectLocations)
            } catch (error) {
                console.error('Error fetching overrides:', error);
            }
            if (responseProjectLocations && responseProjectLocations.data && responseProjectLocations.data.results) {
                this.projectLocations = responseProjectLocations.data.results;
            }

            try {
                responseProjects = await this.oasisV3Api.get('/employer/subprojects');
                // console.log(responseProjects)
            } catch (error) {
                console.error('Error fetching overrides:', error);
            }
            if (responseProjects && responseProjects.data && responseProjects.data.results) {
                this.projects = responseProjects.data.results;
            }
        },

        // Track changes. If there is a second param, it's coming from an autocomplete
        trackChange(arg) {
            if (!arg) return;
            let field
            if (typeof arg === 'string' || typeof arg === 'number') {
                field = arg;
            } else if (typeof arg === 'object' && arg instanceof Event) {
                field = arg.target ? arg.target.name : arg.name;
            } else {
                console.log('unknown field');
            }

            this.changed[field] = true;
            // this.overrideData[field] = data;
            // console.log(field, this.changed, this.overrideData);
            return;
        },

        async saveOverride() {
            if (!this.validate()) return false;

            let endpoint = '/employer/startOverride'
            let data = {};
            let method;
            let response;
            if (this.overrideData && this.overrideData.id) {
                method = 'patch';
                endpoint += `/${this.overrideData.id}`
            } else {
                method = 'post';
                data = this.overrideData;

                // Set status only once on creation
                if (this.send_start) {
                    data.status = 2;
                } else {
                    data.status = 6;
                }
            }

            // Only send changed data
            for (const label in this.changed) {
                data[label] = this.overrideData[label];
            }

            this.loading = true;
            this.showToast('Saving...');
            try {
                response = await this.oasisV3Api[method](endpoint, data);
                console.log('Save response:', response);
            } catch (error) {
                console.error('Error fetching overrides:', error);
            } finally {
                this.loading = false;
            }

            if (response && response.status === 201 && response.data && response.data.id) {
                this.overrideData.id = response.data.id
                this.$emit('save', response.data);
                console.log('Posted successfully');
                // this.rowData = response.data.results;
                this.closeBox();
            } else if (response && response.status === 200 && response.data) {
                this.$emit('save', response.data);
                console.log('Patched successfully');
                this.closeBox();
            } else {
            }
        },
    },

    watch: {
    },

    created() {
        this.getOptionsdata();
    },

    async mounted() {
        setTimeout(() => { $('[data-toggle="tooltip"]').tooltip() }, 500);

        // Prevent back button from failing.
        history.pushState(null, document.referrer, location.href);
        window.onpopstate = function () {
            window.location.href = document.referrer;
        };

        if (this.enableProBooks) {
            this.COAObj = JSON.parse(window.localStorage.getItem(this.assignment.entity_id + '#'));
        }

        if (this.assignment && this.override && this.override.id) {
            if (this.override) this.overrideData = Object.assign({}, this.override);
        } else if (this.assignment && this.assignment.id) {
            this.resetOverride();
        }
    }
});
</script>

<style>
.reviewBox {
    position: absolute;
    right: 100px;
    z-index: 900;
    border: 2px solid red;
    border-radius: 10px;
    /* box-shadow: 2px 20px 40px 30px #666; */
    padding: 20px;
    background-color: white;
    min-width: 500px;
    max-width: 70%;
}
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4); /* Dimming effect */
    backdrop-filter: blur(5px);           /* Optional blur effect */
    z-index: 999;                         /* Sits on top of content */
}
.option {
    font-size: 1.1em;
    font-weight: bold;
    text-decoration: underline;
}
.info {
    font-weight: lighter;
}
.toast-success {
    position: fixed; top: 8%; left: 50%; transform: translate(-50%, -50%);
    background-color: #d6e9c6; z-index: 1001; border-radius: 10px; padding: 20px; max-width: 40%;
    font-size: 1.5em; font-weight: 1000; text-align: center;
}
.toast-error {
    position: fixed; top: 8%; left: 50%; transform: translate(-50%, -50%);
    background-color: #feeeee; z-index: 1001; border-radius: 10px; padding: 20px; max-width: 40%;
    font-size: 1.5em; font-weight: 1000; text-align: center;
}
</style>
